interface RecommendationEngineDataPlaceholderProps {
  title: string
  body: string
}

function RecommendationEngineDataPlaceholder({
  title,
  body,
}: RecommendationEngineDataPlaceholderProps) {
  return (
    <div className="bg-muted/20 border-border rounded-md border p-3">
      <p className="text-foreground text-sm font-medium">{title}</p>
      <p className="text-muted-foreground mt-1 text-sm">{body}</p>
    </div>
  )
}

export function RecommendationEngineNoData({ message }: { message: string }) {
  return (
    <RecommendationEngineDataPlaceholder title="No data yet" body={message} />
  )
}

export function RecommendationEngineMissingData({
  fields,
}: {
  fields: string[]
}) {
  return (
    <RecommendationEngineDataPlaceholder
      title="Missing required fields"
      body={`Missing: ${fields.join(', ')}`}
    />
  )
}
